<div class="flex items-center justify-between mt--4">
  <div class="flex items-center">
    <mat-icon svgIcon="schedule" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'SCHEDULES.SCHEDULES' | transloco}}
      @if(showSchedule){
        <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 : (data?.length || 0)}})</span>
      }
    </div>
    @if(showSchedule){
    <div [ngClass]="{'filter-disabled': !envScheduleResponse || scheduleLoading || schedule?.length === 0}" class="ml-16 search-runbook">
      <app-search-filter class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
    </div>
    <span class="vertical-dash ml-12"></span>
    <button [ngClass]="{'filter-disabled': !envScheduleResponse || scheduleLoading || schedule?.length === 0}" class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-12 filter" (click)="filterColumns()">
      <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
      <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
    </button>
    }
  </div>
  @if (showSchedule && schedule?.length > 0) {
  <div class="flex flex-row gap-3 create-runbook">
    @if ((selectedData?.status === 'enabled' || selectedData?.status === 'created' || selectedData?.status === 'updated' || enablingDisablingStates.includes(selectedData?.status)) && isEditScheduleAllowed && isAzureScheduleStateAllowed()) {
    <button type="submit" [ngClass]="{'disable-enable': enablingDisablingStates.includes(selectedData?.status) || disableCreate || restrictEnableDisable}"
      class="flex disable h-32 fw-700 place-items-center mt-16 mr-8" (click)="enablingDisablingStates.includes(selectedData?.status) || disableCreate || restrictEnableDisable ? null : onDisableSchedule()"
      [matTooltip]="((enablingDisablingStates.includes(selectedData?.status) || disableCreate || restrictEnableDisable)? 'SCHEDULE.DISABLE_NOT_ALLOWED' : '') | transloco"
      matTooltipClass="form-tooltip above" matTooltipPosition="{{Constants.POSITION_ABOVE}}">
      <mat-icon svgIcon="block" class="mr-4 icon-sm"></mat-icon>
      {{ 'BUTTONS.DISABLE' | transloco }}
    </button>
    }
    
    @if ((selectedData?.status === 'disabled' || enablingDisablingStates.includes(selectedData?.status)) && isEditScheduleAllowed && isAzureScheduleStateAllowed()) {
    <button type="submit" [ngClass]="{'disable-enable': enablingDisablingStates.includes(selectedData?.status) || disableCreate || restrictEnableDisable}"
      class="flex enable h-32 fw-700 place-items-center mt-16 mr-8" (click)="enablingDisablingStates.includes(selectedData?.status) || disableCreate || restrictEnableDisable ? null : onEnableSchedule()"
      [matTooltip]="((enablingDisablingStates.includes(selectedData?.status) || disableCreate || restrictEnableDisable)? 'SCHEDULE.ENABLE_NOT_ALLOWED' : '') | transloco"
      matTooltipClass="form-tooltip above" matTooltipPosition="{{Constants.POSITION_ABOVE}}">
      <mat-icon svgIcon="check" class="mr-4 icon-sm"></mat-icon>
      {{ 'BUTTONS.ENABLE' | transloco }}
    </button>
    }
  @if (createSchedule) {
  <button type="submit" class="flex accent h-32 mt-16 mr-8" (click)="(disableCreate || deployingStatus) ? '' : createClick()" [ngClass]="{'disabled': disableCreate || deployingStatus}">
    <mat-icon svgIcon="add" class="mr-6 mt-6 icon-sm"></mat-icon>{{'BUTTONS.CREATE' | transloco}}
  </button>
  <div class="flex items-center border-left mr-4"></div>
  }
  <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshClick()">
    <mat-icon svgIcon="refresh" class="icons transition-transform duration-700" [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
  </div>
  <app-environment-paginator [length]="searchedResult?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize" (page)="onPageChange($event)"></app-environment-paginator>
  </div>
  }
</div>
<div *ngIf="selectedStatus?.length > 0 || filterStartDate && filterEndDate" class="flex flex-row flex-wrap items-center ml-8">
          @if (selectedStatus?.length > 0) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.STATUS' | transloco }}</span>
          }  
         <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
               <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getStatusLabel(status) | titlecase}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
               </span>
         </div>
         @if (filterStartDate && filterEndDate) {
            <span class="pr-8 fs-16">{{ 'SCHEDULE_DETAILS.MODIFIED_DATE' | transloco }}:</span>
          }
         <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="filterStartDate && filterEndDate">
            <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
               {{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
               <span class="ml-8">
               <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelEnvScheduleDateFilter()"></mat-icon>
               </span>
            </span>
         </div>
         <div class="flex flex-row items-center">
            <span *ngIf="selectedStatus?.length > 0 || selectedType?.length > 0 || selectedVersion?.length > 0 || (filterStartDate && filterEndDate)" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetEnvscheduleFilter()">
               {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
         </div>
      </div>
<mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
@if (envScheduleResponse && !showLoader && showSchedule) {
<div class="flex flex-col border-radius route-table envt-schedule mb-16 mt-8">
  <app-environment-table class="runbook-table" 
  (approve)="getApproveData($event)" [instance]="instance" [ngClass]="{'disabled': showLoader}" (searchedResults)="searchedItems($event)" 
  [displayColumns]="displayColumns" [showSkeletonLoader]="scheduleLoading" [initialDataSource]="data" [dataLoading]="scheduleLoading" 
  [searchTerm]="searchTerm"  (goToJobs)="redirectToJobs($event)" [dataSourceLength]="true" [initialCreate]="schedule?.length === 0" 
  (pageChanged)="onPageChange($event)" (sorted)="resetPaginator()" (pageModify)="onTablePageChanged($event)" (pageChanged)="onPageChange($event)" 
  pageName="environmentSchedule" (editScheduleEmit)="editSchedule($event)" (deleteScheduleEmit)="fetchSchedule()"></app-environment-table>
</div>
}
@if(!envScheduleResponse && !apiNotFound && !showLoader && showSchedule && !schedule?.length) {
<div class="flex flex-col" >
  <div class="flex flex-col empty-panel ml-10 mr-16 mt-16">
    <div class="empty-data flex flex-col items-center mt-32 ">
      <img class="w-106" alt="schedule not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6 ">{{'SCHEDULE.NO_SCHEDULE' | transloco }}</div>
    </div>
    @if(createSchedule) {
    <div class="flex justify-center mt-24">
      <button  type="button" class="flex accent justify-center items-center mat-subtitle-2" mat-button
        (click)="disableCreate ? '' : createClick()" [ngClass]="{'disabled': disableCreate}">
        <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
        {{'BUTTONS.CREATE' | transloco }}
      </button>
    </div>
    }
  </div>
</div>
}
@if(!showSchedule && isDataLoaded ){
  <div class="pt-38 unauth-container pb-50 mb--20">
    <img class="image" src="/assets/images/unauthorized.svg">
    <div class="fw-600 fs-20 mat-subtitle-2 mt-32"> {{ 'UNAUTHORIZED.MESSAGE' | transloco }}</div>
  </div>
}
@if (showLoader && scheduleLoading) {
<div class="loader-section">
  <div class="runbook-group loader-header flex flex-col p-16">
    <div class="flex flex-row">
      @for (tableColumn of displayColumns; track tableColumn?.key) {
        <div class="loader-style">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>

  @for (item of [1, 2, 3]; track $index) {
    <div class="w-100-percent">
    <div class="runbook-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
          <div class="loader-style">
            <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    </div>
  }
</div>
}